/* Lenis smooth-scroll singleton + anchor helper */
let lenis = null;

export function setLenis(instance) {
  lenis = instance;
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) {
    lenis.scrollTo(el, { offset: -72, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
